import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { useImagesLoaded } from '../../hooks/useImagesLoaded';
import { useShareablesTemplateRoot } from '../../hooks/useShareablesTemplateRoot';
import { COLOR_BLACK, COLOR_WHITE } from '../colors';
import { CONTENT_THEME_CLASSES } from './contentThemes';
import { nl2br } from '../../utils';
import { Textfit } from 'react-textfit';

const MIN_BODY_FONT_SIZE = 24;
const MAX_BODY_FONT_SIZE = 72;
const SINGLE_LINE_THRESHOLD = 35; // number of characters above this will switch to multi line textfit

const useStyles = makeStyles((theme)=> ({
    wrap: ({ contentTheme })=> ({
        fontFamily: ['"LL Circular Pro"', 'Arial', 'Helvetica', 'sans-serif'],
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        padding: '70px 104px',
        justifyContent: 'center',
        textAlign: 'center',
        ...(contentTheme && CONTENT_THEME_CLASSES[contentTheme]?.wrap)
    }),
    container: {
        position: 'relative',
        minWidth: '100%',
        maxHeight: '100%',
        overflow: 'hidden',
    },
    body: ({ contentTheme })=> ({
        display: 'inline-block',
        lineHeight: 1.3,
        backgrounColor: COLOR_WHITE,
        color: contentTheme === 'uploaded' ? COLOR_WHITE : COLOR_BLACK,
        ...(contentTheme && CONTENT_THEME_CLASSES[contentTheme]?.body)
    }),
    watermark: {
        position: 'absolute',
        left: '50%',
        bottom: '30%',
        zIndex: 9999,

        '& img': {
            position: 'relative',
            left: '-50%',
        },
    }
}));

export default function CustomShareable(props) {
    const {
        rootClasses,
        parsedData,
        onImagesLoaded,
    } = useShareablesTemplateRoot(props);
    const {
        shareable_image_url,
        body,
        watermark = false,
        contentTheme,
    } = parsedData || {};
    const { border = 'none' } = props;
    const classes = Object.assign({}, rootClasses, useStyles({ contentTheme }));
    const loadedBgs = useImagesLoaded([shareable_image_url]);

    useEffect(() => {
        if(loadedBgs && !window.isLoaded) {
            if(typeof onImagesLoaded === 'function') {
                onImagesLoaded();
            } else {
                window.isLoaded = true;
            }
        }
    }, [loadedBgs, onImagesLoaded]);

    if(!parsedData) return null;

    return (
        <>
            <link rel="stylesheet" href="./css/ll-circular-pro.css" />
            <div className={classes.root} id="templateRoot">
                <div className={classes.viewport}>
                    <div className={classes.wrap}
                        style={{
                            border,
                            ...(shareable_image_url && {
                                backgroundImage: `${body ? 'linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), ' : ''}url("${shareable_image_url}")`
                            })
                        }}
                    >
                        <div className={classes.container}>
                            {body && (
                                <Textfit mode={body?.length > SINGLE_LINE_THRESHOLD ? 'multi' : 'single'}
                                    min={MIN_BODY_FONT_SIZE}
                                    max={MAX_BODY_FONT_SIZE}>
                                    <div className={classes.body}>
                                        <span dangerouslySetInnerHTML={{__html: nl2br(body)}}></span>
                                    </div>
                                </Textfit>
                            )}
                        </div>

                        {watermark && (<div className={classes.watermark}>
                            <img src="./images/watermark-stamp.svg" alt="Watermark" />
                        </div>)}
                    </div>
                </div>
            </div>
        </>
    );
}
